import * as t from 'io-ts';

export const Csrf = t.type({
  csrf: t.string,
});
export type Csrf = t.TypeOf<typeof Csrf>;
